import Kanri from './KanriApp.vue';
import kanriMenu from './templates/KanriMenu.vue';
import organizationMenu from './templates/OrganizationMenu.vue';
import organizationInfo from './templates/OrganizationInfo.vue';
import organizationSearch from './templates/OrganizationSearch.vue';
import userMenu from './templates/UserMenu.vue';
import userInfo from './templates/UserInfo.vue';
import userSearch from './templates/UserSearch.vue';
import userChangePassword from './templates/UserChangePassword.vue';
import masterCodeMenu from './templates/MasterCodeMenu.vue';
import masterCodeTableInfo from './templates/MasterCodeTableInfo.vue';
import masterCodeTableSearch from './templates/MasterCodeTableSearch.vue';
//import masterCodeInfo from './templates/MasterCodeInfo.vue';
import masterCodeSearch from './templates/MasterCodeSearch.vue';
import masterEditionSearch from './templates/MasterEditionSearch.vue';  // 2023.07.04 [2023F-02] add
import masterEditionInfo from './templates/MasterEditionInfo.vue';  // 2023.07.04 [2023F-02] add
import mailTemplateInfo from './templates/MailTemplateInfo.vue';  // 2023.07.19 [2023F-06] add
import mailOrganizationInfo from './templates/MailOrganizationInfo.vue';  // 2023.08.08 [2023F-07] add
import mailScheduleSearch from './templates/MailScheduleSearch.vue';  // 2023.10.31 [2023L-08] add
import mailScheduleInfo from './templates/MailScheduleInfo.vue';  // 2023.10.31 [2023L-08] add
import mailScheduleContentInfo from './templates/MailScheduleContentInfo.vue';  // 2023.10.31 [2023L-08] add

export default {
  path: '/kanri',
  component: Kanri,
  children: [
    {
      name: 'kanri-top',
      path: '/',
      component: kanriMenu,
    },
    {
      name: 'organizationMenu',
      path: 'organization',
      component: organizationMenu,
    },
    {
      name: 'organizationInfo',
      path: 'organization/info',
      component: organizationInfo,
    },
    {
      name: 'organizationSearch',
      path: 'organization/search',
      component: organizationSearch,
    },
    {
      name: 'userMenu',
      path: 'user',
      component: userMenu,
    },
    {
      name: 'userInfo',
      path: 'user/info',
      component: userInfo,
    },
    {
      name: 'userChangePassword',
      path: 'user/info/password',
      component: userChangePassword,
    },
    {
      name: 'userSearch',
      path: 'user/search',
      component: userSearch,
    },
    {
      name: 'masterCodeMenu',
      path: 'masterCode',
      component: masterCodeMenu,
    },
    {
      name: 'masterCodeTableInfo',
      path: 'masterCodeTable/info',
      component: masterCodeTableInfo,
    },
    {
      name: 'masterCodeTableSearch',
      path: 'masterCodeTable/search',
      component: masterCodeTableSearch,
    },
    // {
    //   name: 'masterCodeInfo',
    //   path: 'masterCode/info',
    //   component: masterCodeInfo,
    // },
    {
      name: 'masterCodeSearch',
      path: 'masterCode/search',
      component: masterCodeSearch,
    },
    // 2023.07.04 [2023F-02] add start
    {
      name: 'masterEditionSearch',
      path: 'masterEdition/search',
      component: masterEditionSearch,
    },
    {
      name: 'masterEditionInfo',
      path: 'masterEdition/info',
      component: masterEditionInfo,
    },
    // 2023.07.04 [2023F-02] add end
    // 2023.07.19 [2023F-06] add start
    {
      name: 'mailTemplateInfo',
      path: 'mailTemplate/info',
      component: mailTemplateInfo,
    },
    // 2023.07.19 [2023F-06] add end
    // 2023.08.08 [2023F-07] add start
    {
      name: 'mailOrganizationInfo',
      path: 'mailOrganization/info',
      component: mailOrganizationInfo,
    },
    // 2023.08.08 [2023F-07] add end
    // 2023.10.31 [2023L-08] add start
    {
      name: 'mailScheduleSearch',
      path: 'mailSchedule/search',
      component: mailScheduleSearch,
    },
    {
      name: 'mailScheduleInfo',
      path: 'mailSchedule/info',
      component: mailScheduleInfo,
    },
    {
      name: 'mailScheduleContentInfo',
      path: 'mailSchedule/info/content',
      component: mailScheduleContentInfo,
    },
    // 2023.10.31 [2023L-08] add end
  ],
};
